import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ChevronRightIcon } from 'lucide-react';
import { AtnaAssistant } from '../components/collectes/AtnaAssistant';
import { AddressCard } from '../components/collectes/AddressCard';
import { CollectionCalendar } from '../components/collectes/CollectionCalendar';
import { DayDetails } from '../components/collectes/DayDetails';
export function CalendrierCollectes() {
  const [month, setMonth] = useState(new Date(2026, 8, 1));
  const [selected, setSelected] = useState(new Date(2026, 8, 30));
  const handleSelect = (date: Date) => {
    setSelected(date);
    if (date.getMonth() !== month.getMonth()) setMonth(new Date(date.getFullYear(), date.getMonth(), 1));
  };
  return <main className="bg-white" data-id="element-2967" data-mp="29ws9u8ycqs5u">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2968" data-mp="akpjqfv82zj7">
        <nav aria-label="Fil d’Ariane" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-2969" data-mp="amsknuxwyd2p">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2970" data-mp="35253d6z9iqpc">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2971" data-mp="30b6lw42jfmki" />
          <Link to="/mes-collectes" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2972" data-mp="2vcbsy9auwhmo">
            Mes collectes
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2973" data-mp="2rbs03hxbg06c" />
          <span aria-current="page" data-id="element-2974" data-mp="3o0r9j09mz804">Calendrier</span>
        </nav>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-2975" data-mp="3nywu21h4w83f">
          <div data-id="element-2976" data-mp="3j2g02qn96zif">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2977" data-mp="3iztnudpf3vtv">Mes collectes</h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-2978" data-mp="3a18bj0ajhd1j">Calendrier personnalisé pour votre adresse</p>
          </div>
        </header>

        <div className="mt-8" data-id="element-2979" data-mp="23lfpu0ellrcl">
          <AtnaAssistant data-id="element-2980" data-mp="23mh3mcn00ry0" />
        </div>

        <div className="mt-6" data-id="element-2981" data-mp="1ymckeeuphj43">
          <AddressCard data-id="element-2982" data-mp="1yl1gmf19gbcz" />
        </div>

        <Link to="/mes-collectes" className="mt-6 inline-flex items-center gap-1.5 text-sm font-bold text-ville-deep underline underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2983" data-mp="1yo5vq7g9krif">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-2984" data-mp="1v45c77zog6jn" />
          Retour à Mes collectes
        </Link>

        <div className="mt-6 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,420px)] lg:gap-10" data-id="element-2985" data-mp="1hd0iemizq8h8">
          <CollectionCalendar month={month} selected={selected} onMonthChange={setMonth} onSelect={handleSelect} data-id="element-2986" data-mp="1m37aiwcpob48" />
          <DayDetails date={selected} data-id="element-2987" data-mp="17fcfh9b8dunz" />
        </div>
      </div>
    </main>;
}